import { useGetCurrentStudentDebtsQuery } from 'src/api/endpoints/students/personal/api';
import { AuthorizedUserProps } from 'src/routes/components/PrivateRoute';
import { FC, ReactElement, useMemo } from 'react';
import {
    DebtStatus,
    StudentDebt,
} from 'src/pages/employees/BranchStudentDebtsPage';
import { filter, sumBy } from 'lodash';
import { IconProps } from 'src/pages/edu/Statistic';
import './module.scss';

export const DebtPage: FC<AuthorizedUserProps> = (): ReactElement => {
    const { data: debts } = useGetCurrentStudentDebtsQuery();

    const activeDebts = useMemo(() => {
        const activeDebts: StudentDebt[] = filter(
            debts,
            (d: StudentDebt): boolean => d.status === DebtStatus.Active
        );

        return {
            amount: sumBy(activeDebts, d => Number(d.amount)),
            quantity: activeDebts.length,
            elements: activeDebts,
        };
    }, [debts]);

    return (
        <main id={'student-debt-page'}>
            <div className="debt-info">
                <div className="title">Текущая задолженность</div>
                <div className="amount">
                    {activeDebts.amount.toLocaleString('ru-ru')}
                    <span className={'currency'}>{' ₽'}</span>
                </div>
            </div>
            <div className="notification">
                <div className={'notification-icon'}>
                    <div className="icon-wrapper">
                        <LockIcon size={'50px'} color={'#eb4247'} />
                    </div>
                </div>
                <div className="notification-content">
                    <div className={'notification-title'}>Доступ запрещен</div>
                    <div className={'notification-description'}>
                        Доступ к платформе был временно ограничен по причине
                        наличия активной задолженности. Обратитесь в учебный
                        отдел вашего филиала.
                    </div>
                </div>
            </div>
        </main>
    );
};

export const LockIcon = (props: IconProps) => {
    const { size = '16px', color = '#000000' } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={size}
            viewBox="0 -960 960 960"
            width={size}
            fill={color}
        >
            <path d="M226.67-80q-27.5 0-47.09-19.58Q160-119.17 160-146.67v-422.66q0-27.5 19.58-47.09Q199.17-636 226.67-636h60v-90.67q0-80.23 56.57-136.78T480.07-920q80.26 0 136.76 56.55 56.5 56.55 56.5 136.78V-636h60q27.5 0 47.09 19.58Q800-596.83 800-569.33v422.66q0 27.5-19.58 47.09Q760.83-80 733.33-80H226.67Zm0-66.67h506.66v-422.66H226.67v422.66Zm308.5-155.85Q558-325.04 558-356.67q0-31-22.95-55.16Q512.11-436 479.89-436t-55.06 24.17Q402-387.67 402-356.33q0 31.33 22.95 53.83 22.94 22.5 55.16 22.5t55.06-22.52ZM353.33-636h253.34v-90.67q0-52.77-36.92-89.72-36.93-36.94-89.67-36.94-52.75 0-89.75 36.94-37 36.95-37 89.72V-636ZM226.67-146.67v-422.66 422.66Z" />
        </svg>
    );
};
